import { withDatasourceCheck, LinkField, Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import { ComponentProps } from 'lib/component-props';
import { useI18n } from 'next-localization';

type SocialNetworkItem = Item & {
  fields: {
    icon: Field<string>;
    link: LinkField;
  };
};

type SocialNetworksProps = ComponentProps & {
  fields: {
    items: Array<SocialNetworkItem>;
  };
};

const SocialNetwork = (props: SocialNetworksProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor: boolean | undefined = sitecoreContext && sitecoreContext.pageEditing;
  const { t } = useI18n();
  return (
    <div className="d-flex social-networks justify-content-end">
      {props.fields.items &&
        props.fields.items.length &&
        props.fields.items.map((icon, index) => (
          <a
            key={index}
            href={icon.fields.link.value.href}
            className={`icon d-flex align-items-center justify-content-center ${
              index !== props.fields.items.length - 1 ? 'me-3' : ''
            }`}
            target="_blank"
            aria-label={icon.fields.icon.value}
          >
            {icon.fields.icon.value && (
              <em className={`bi-${icon.fields.icon.value}`} aria-hidden="true" />
            )}
            {!icon.fields.icon.value && isExperienceEditor && <p>[no icon selected]</p>}
            <span className="sr-only">{t('opensInNewWindow')}</span>
          </a>
        ))}
      {props.fields.items?.length && isExperienceEditor && (
        <p className="social-networks-placeholder">[Social Networks]</p>
      )}
    </div>
  );
};

export default withDatasourceCheck()<SocialNetworksProps>(SocialNetwork);
